import shaneHeashot from '../ShaneHeadShot.png'

export default function AboutUs() {
    return (
        <div className='AboutUs'>
            <div className="ContactInfoCard">

                <div className="Name">SHANE KNUDSEN</div>
                <div>
                    <a className="PhoneNumber" href="tel:4352627460">(435) 262-7460</a>
                </div>
                <div>
                    <a className="Email" href="mailto:knudsen.insurance@gmail.com">Knudsen.Insurance@gmail.com</a>
                </div>

            </div>
            <div className="ContactInfoPicture">
                <img src={shaneHeashot} alt="Shane"></img>
            </div>
        </div>
    );
}